<template>
  <section
    class="tw-h-[calc(100vh-104px)] tw-w-full tw-flex tw-flex-col tw-justify-center tw-items-center tw-text-center tw-gap-4"
  >
    <div
      class="tw-text-contact-us-header-mobile apTablet2:tw-text-contact-us-header-desktop tw-text-nowrap tw-text-ap-nero tw-px-[20px]"
    >
      Thank you.</div>
    <p
      class="tw-text-body-md-mobile apTablet2:tw-text-body-md-desktop tw-max-w-[310px] apTablet2:tw-max-w-[600px] tw-text-ap-nero"
    >
      Someone from our team will get back to you as soon as possible. Meanwhile, <a class="tw-cursor-pointer" @click="onClickOurWork">check out some of the
        projects we’ve done.</a>
    </p>
  </section>
</template>

<script setup lang="ts">

const emit = defineEmits(['click-our-work']);

function onClickOurWork() {
  emit('click-our-work');
}
</script>

<style scoped>
a {
  color: #007AFF;
  text-decoration: underline;
  text-underline-offset: 4px;
}
</style>